const stats = [
  { value: "5000+", label: "在线番剧" },
  { value: "12万+", label: "连载漫画" },
  { value: "8年+", label: "陪伴成长" },
  { value: "24小时", label: "稳定追番" },
];

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[560px] w-full flex-col items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20anime%20illustration%20of%20a%20lively%20Japanese%20shopping%20street%20at%20sunset%20with%20warm%20coral%20orange%20sky%2C%20glowing%20paper%20lanterns%2C%20colorful%20storefronts%20with%20manga%20posters%2C%20floating%20cherry%20blossom%20petals%2C%20soft%20bokeh%2C%20dreamy%20youthful%20atmosphere%2C%20high%20detail%20digital%20anime%20art%2C%20warm%20golden%20orange%20and%20pink%20palette&width=1600&height=900&seq=anime-hero-01&orientation=landscape"
        alt="动漫之家动漫街区插画背景"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="mb-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-black/20 px-4 py-1.5 text-xs md:text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-400"></i>
          官网地址实时更新 · 一键回到追番现场
        </span>

        <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          动漫之家
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/95 md:text-lg">
          动漫之家打不开、换网址找不到新站？这里整理当前可用的动漫之家官网入口、网页版与
          APP 下载地址，帮你快速回到熟悉的追番与追漫页面。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#access"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-link mr-1"></i>进入网页版
          </a>
          <a
            href="#webapp"
            className="whitespace-nowrap rounded-full border border-background-50/70 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-smartphone-line mr-1"></i>下载 APP
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-50/25 bg-black/20 px-4 py-4 text-center backdrop-blur"
            >
              <dt className="order-2 text-xs text-background-50/80">{s.label}</dt>
              <dd className="font-heading text-2xl text-background-50 md:text-3xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}